export const isExpiredToken = (fluidToken: string): boolean => {
    if (fluidToken) {
        let expiryDate = JSON.parse(atob(fluidToken.split(".")[1])).exp
        return (Date.now() >= expiryDate);
    }
    return true;

}